import { Component, input, OnChanges, SimpleChanges } from '@angular/core';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule, MatTable, MatTableDataSource } from '@angular/material/table';
import { TableColumn, TableConfig } from '../../../models/table.models';


@Component({
  selector: 'app-table',
  imports: [MatTableModule, MatSortModule],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
  standalone: true
})
export class TableComponent implements OnChanges {

  data = input<any[]>([]);
  columns = input<TableColumn[]>([]);
  config = input<TableConfig>({
    enablePagination: false,
    enableSort: false,
    enableSearch: false,
    enableFilter: false,
    enableCSVDownload: false,
    enableExcelDownload: false,
    pageSize: 10,
    pageSizeOptions: [5, 10, 25, 100]
  });
  displayedColumns: string[] = [];
  dataSource!: MatTableDataSource<any>;

  constructor() { 
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.dataSource = new MatTableDataSource(this.data());
      const newColumns = this.columns();
        this.displayedColumns = this.config().showSerialNumber
          ? ['serialNumber', ...newColumns.map(col => col.key)]
          : newColumns.map(col => col.key);
    }
  }

}
